import usePlan from "../hooks/use-plan";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";

export default function AccountPage() {
  const { data, loading, error } = usePlan();

  if (loading) return <div>Loading account...</div>;
  if (error) return <div>Error loading account: {error}</div>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-semibold mb-4">Account & Plan</h1>
      <Card>
        <div className="p-4">
          <p className="mb-2">Current plan: <strong>{data?.plan}</strong></p>
          <p className="mb-2">Billing month: {data?.year_month}</p>
          <div className="mb-2">
            <p>Messages processed this month: <strong>{data?.usage.messages_processed}</strong></p>
            <p>Products synced this month: <strong>{data?.usage.products_synced}</strong></p>
          </div>
          <div className="flex gap-2 mt-4">
            <Button onClick={() => alert('Upgrade flow not implemented yet')}>Upgrade</Button>
            <Button variant="ghost" onClick={() => alert('Contact support to change plan')}>Contact Support</Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
